import { SPEC_OPTION_TYPES } from '@/pages/AssetConfiguration/specOptionTypes'

export interface AssetCatalogNavItem {
  label: string
  /** Path segment under `/organization/clients/:clientId/asset-catalog` */
  segment: string
  match: (relativePath: string) => boolean
  /** Optional visual group for the left rail */
  group?: 'core' | 'specs' | 'other'
}

/** Spec option order matching sima-admin Asset Create form sections. */
const SPEC_NAV_ORDER = [
  'sw-provider',
  'ram',
  'disk-space',
  'ms-office',
  'processor',
  'cpu',
  'os-version',
] as const

const specItems: AssetCatalogNavItem[] = SPEC_NAV_ORDER.filter(
  (slug) => SPEC_OPTION_TYPES[slug]
).map((slug) => {
  const t = SPEC_OPTION_TYPES[slug]
  return {
    label: t.label === 'Software Provider' ? 'SW Provider' : t.label,
    segment: `spec/${t.slug}`,
    group: 'specs' as const,
    match: (p: string) => p === `spec/${t.slug}` || p.startsWith(`spec/${t.slug}/`),
  }
})

/**
 * Left-rail menu for the client Asset Catalog workspace.
 * Order: Overview → Assets → Core → Spec options (Create Asset dropdown sources).
 */
export const ASSET_CATALOG_NAV: AssetCatalogNavItem[] = [
  {
    label: 'Overview',
    segment: 'overview',
    match: (p) => p === '' || p === 'overview' || p.startsWith('overview/'),
  },
  {
    label: 'Assets',
    segment: 'assets',
    match: (p) => p === 'assets' || p.startsWith('assets/'),
  },
  {
    label: 'Categories',
    segment: 'categories',
    group: 'core',
    match: (p) => p === 'categories' || p.startsWith('categories/'),
  },
  {
    label: 'Functions',
    segment: 'functions',
    group: 'core',
    match: (p) => p === 'functions' || p.startsWith('functions/'),
  },
  {
    label: 'Brands',
    segment: 'brands',
    group: 'core',
    match: (p) => p === 'brands' || (p.startsWith('brands/') && !p.startsWith('brands-models')),
  },
  {
    label: 'Models',
    segment: 'brand-models',
    group: 'core',
    match: (p) => p === 'brand-models' || p.startsWith('brand-models/'),
  },
  ...specItems,
]

export function assetCatalogBasePath(clientId: string | number): string {
  return `/organization/clients/${clientId}/asset-catalog`
}

export function assetCatalogPath(clientId: string | number, segment = 'overview'): string {
  const base = assetCatalogBasePath(clientId)
  const clean = segment.replace(/^\/+/, '')
  return clean ? `${base}/${clean}` : `${base}/overview`
}
